"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
if (!Array.prototype.findAll) {
    Array.prototype.findAll = function (callback) {
        return this.filter(function (e) { return callback(e); });
    };
}
